<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="addOrEdit" :loading="btnLoading" type="primary">下一步</el-button>
    </div>
    <div>
      <div class="main">
        <el-form :model="project" ref="ruleForm" label-position="right" class="mainfrom">
          <div>
            <div class="row content-title" v-if="$store.getters.loginUser.comtype=='1'" >
              <el-form-item label="委托协议" prop="projectpcomid" verify>
                  <!-- <div class="value">{{project.projectpcomname}}</div> -->
                  <el-input v-model="project.ptcinfo" style="width:470px;" :maxlength="20" :disabled="true"></el-input>
                  <vxe-button  type="primary" @click="showptcBox" icon="el-icon-search" style="height:38px;"></vxe-button>
              </el-form-item>
              <el-form-item label="业务员">
                  <div class="value" v-show="project.cdptname">
                      {{project.cdptname}}  /  {{project.dptusername}}
                  </div>
              </el-form-item>
            </div>
            <div class="row from_input from-value" v-if="$store.getters.loginUser.comtype=='2'" >
              <el-form-item label="采购人" prop="projectpcomid" verify>
                  <div class="value">{{project.projectpcomname}}</div>
              </el-form-item>
              <el-form-item label="联系人" prop="projectpuserid" verify>
                  <div class="value">{{project.projectpusername}}</div>
              </el-form-item>
              <el-form-item  label="联系电话" prop="projectptel" verify>
                <el-input v-model="project.projectptel" :maxlength="20"></el-input>
              </el-form-item>
            </div>
            <!-- 代理单位显示 -->
            <div class="row from_input"  verify v-else>
              <el-form-item label="采购人" prop="projectpcomid">
                <!-- <el-select v-model="project.projectpcomid" :filterable="true" :clearable="true"
                            @change="getpUserList" >
                  <el-option v-for="(item, index) in pcomList" :label="item.label" :value="item.value"
                              :key="index"></el-option>
                </el-select> -->
                <el-input v-model="project.pcomfullname" :maxlength="20"  :disabled="true"></el-input>
                <!-- <vxe-button  type="primary" @click="showPcom" icon="el-icon-search" style="height:38px;"></vxe-button> -->
              </el-form-item>
              <el-form-item label="联系人" prop="projectpuserid" verify>
                <el-select v-model="project.projectpuserid" :clearable="true" :filterable="true"
                            @change="getpUserTel">
                  <el-option v-for="(item, index) in puserList" :label="item.label" :value="item.value"
                              :key="index"></el-option> 
                </el-select>
              </el-form-item>
              <el-form-item label="联系方式" prop="projectptel" verify>
                <el-input v-model="project.projectptel" :maxlength="20"></el-input>
              </el-form-item>
            </div>
            <div class="content-title">
              <el-form-item label="项目名称" prop="projectname" verify>
                <el-input v-model="project.projectname" :maxlength="128" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="品目类型" prop="projectpmid" verify>
                <el-cascader :show-all-levels="false"
                  v-model="project.projectpmid"
                  :options="pmTreeList"
                  :props="{ expandTrigger: 'hover' }"
                ></el-cascader>
              </el-form-item>
            </div>
             <!-- <template class="from_input" v-if="+cos.cosprojectcodeflag === 1">
                <div class="row">
                   <el-form-item label="资金来源" prop="pfsid" verify>
                    <el-select v-model="project.pfsid">
                      <el-option v-for="(item, index) in pfsList" :label="item.pfsname" :value="item.pfsid"
                                :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="项目性质" prop="pnid" verify>
                    <el-select v-model="project.pnid">
                      <el-option v-for="(item, index) in pnrecList" :label="item.pnname" :value="item.pnid"
                                :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所在地区" prop="projectnoticeareacode" verify>
                    <el-select v-model="project.projectnoticeareacode" @change="changeArea">
                      <el-option v-for="item in areaList" :label="item.label" :value="item.dptareacode"
                                :key="item.dptareaid"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </template> -->
            <div class="from_input">
              <div class="row">
                <el-form-item label="交易方式" prop="prsflg" verify>
                  <el-select v-model="project.prsflg"  @change="prsflgChange" placeholder="请选择">
                    <el-option
                      v-for="item in projectprsflgList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="from-value" label="评审方法" prop="projectdoneflg" verify>
                  <!-- <div class="value" style="width:204px;" v-if="this.project.prsflg">{{project.projectdoneflgdesc}}</div> -->
                  <!-- <div class="value" v-else-if="this.project.prsflg == '4' || this.project.prsflg == '5'" style="width:204px;">{{project.projectdoneflgdesc}}</div> -->
                  <el-select v-model="project.projectdoneflg" @change="projectdoneflgChange" :clearable="true">
                      <el-option v-for="(item, index) in projectdoneflgList" :label="item.label" :value="item.value"
                      :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item class="from-value" label="价格计分" v-if="this.project.prsflg == '4' || this.project.prsflg == '3'|| this.project.prsflg == '5'">
                  <div >
                    {{project.projectpricecomputebasisdesc}}
                  </div>
                </el-form-item> -->
                <el-form-item class="from-value" label="价格计分"  prop="projectpricecomputebasis" verify>
                  <div  v-if="this.project.prsflg == '4' || this.project.prsflg == '5'">
                    {{project.projectpricecomputebasisdesc}}
                  </div>
                  <div v-else>
                    <el-select v-model="project.projectpricecomputebasis" :clearable="true">
                    <el-option v-for="(item, index) in projectpricecomputebasisList" :label="item.label" :value="item.value"
                    :key="index"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                
                <el-form-item v-if="+project.projectpricecomputebasis===3 || +project.projectpricecomputebasis===4" label="平均价浮动率" prop="projectaveragepriceshift" verify comdifyValdate>
                  <el-input v-model="project.projectaveragepriceshift"
                            @blur="inputMoney($event,'projectlimitamt')"
                            :maxlength="12"></el-input>
                </el-form-item>
                <!--<el-form-item label="品目类型" prop="projectchargefeetype" verify>-->
                  <!--<el-select v-model="project.projectchargefeetype" placeholder="请选择">-->
                    <!--<el-option-->
                      <!--v-for="item in pojectpmflgList"-->
                      <!--:key="item.value"-->
                      <!--:label="item.label"-->
                      <!--:value="item.value">-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                <!--</el-form-item>-->
                <!-- <el-form-item label="品目类型" prop="projectpmid" verify>
                  <el-cascader :show-all-levels="false"
                    v-model="project.projectpmid"
                    :options="pmList"
                    :props="{ expandTrigger: 'hover' }"
                  ></el-cascader> -->
                  <!--<el-select v-model="project.projectpmid" filterable placeholder="请选择">-->
                    <!--<el-option-group-->
                      <!--v-for="group in pmTreeList"-->
                      <!--:key="group.value"-->
                      <!--:label="group.label"-->
                      <!--:value="group.value">-->
                      <!--<el-option v-for="item in group.children":key="item.value"-->
                                 <!--:label="item.label"-->
                                 <!--:value="item.value">-->
                      <!--</el-option>-->
                    <!--</el-option-group>-->
                  <!--</el-select>-->
                <!-- </el-form-item> -->
              </div>
              <div class="row" v-if="isScoreEdit">
                <el-form-item label="履约分值" prop="projectperformancescore" verify scoreVerify>
                  <el-input  @blur="scoreFixed($event, 'projectperformancescore')" v-model="project.projectperformancescore"></el-input>
                </el-form-item>
              </div>
              <div class="row">
                <el-form-item :label="`${limitamtNmae}`" prop="projectlimitamt" verify comdifyValdate>
                  <div>
                    <el-input v-model="project.projectlimitamt"
                      @blur="inputMoney($event,'projectlimitamt')"
                      :maxlength="12">
                      <template slot="append"><span >元</span></template>
                    </el-input>
                    <!-- <div style="color:red;margin-top:2px;font-size:12px;"> -->
                      <amount :money="String(project.projectlimitamt)" class="el-form-item__error" v-if="project.projectlimitamt"/>
                    <!-- </div> -->
                  </div>
                </el-form-item>
                <el-form-item :label="`${publicname}`">
                  <div class="checkbox_w" v-if="+project.prsflg === 4 || +project.prsflg === 5">
                    {{project.projectysflg===true?'公开':'不公开'}}
                  </div>
                  <div class="checkbox_w" v-else>
                    <el-checkbox v-model="project.projectysflg"></el-checkbox>
                  </div>
                </el-form-item>
                <el-form-item label="报价含税">
                  <div class="checkbox_w">
                    <el-checkbox v-model="project.projecthsflg"></el-checkbox>
                  </div>
                </el-form-item>
                <el-form-item label="报价方式" prop="projectquotationmode" verify v-if="+project.prsflg === 1 || +project.prsflg === 3 || +project.prsflg === 6">
                  <!-- <div class="value">{{project.ausername}}</div> -->
                  <el-select v-model="project.projectquotationmode"  @change="quotationmodeChange">
                    <el-option v-for="(item, index) in quotationList" :label="item.label" :value="item.value"
                               :key="index"></el-option>
                   </el-select>
                </el-form-item>
              </div>
              <div class="row from-value" v-if="$store.getters.loginUser.comtype=='1'">
                <el-form-item label="代理机构" prop="projectacomid" verify>
                  <div class="value">{{project.acomfullname}}</div>
                  <!--<el-select v-model="project.projectacomid" @change="getaUserList">-->
                    <!--<el-option v-for="(item, index) in acomList" :label="item.label" :value="item.value"-->
                               <!--:key="index"></el-option>-->
                  <!--</el-select>-->
                </el-form-item>
                <el-form-item label="联系人" prop="projectauserid" verify>
                  <!-- <div class="value">{{project.ausername}}</div> -->
                  <el-select v-model="project.projectauserid" @change="getaUserTel">
                    <el-option v-for="(item, index) in auserList" :label="item.label" :value="item.value"
                               :key="index"></el-option>
                   </el-select>
                </el-form-item>

                <el-form-item label="联系电话" prop="projectatel" verify>
                  <!-- <div class="value">{{project.projectatel}}</div> -->
                  <el-input v-model="project.projectatel" :maxlength="20"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <!-- <el-form-item label="需求附件" v-if="+$store.getters.loginUser.comtype === 1 || +$store.getters.loginUser.comtype === 2">
            <upload-file-more :fileList="fileList" :isUplaodFlag="type === 3 ? 0 : 1" folderName="project"
            @changed='setfile' text="选择文件"></upload-file-more>
            <div class="file">
              <div class="uploadbtn">
                <upload-btn @changed='setfile' text="上传附件"></upload-btn>
                <span>(仅限采购和代理人内部使用)</span>
              </div>
              <div v-if="appendList.length" class="filelist">
                <div v-for="(item,index) in appendList" :key="index" class="fileitem">
                  <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename | toolongOmitted}}</a>
                  </div>
                  <div class="btn" @click="delappend(item)"><span>删除</span></div>
                </div>
              </div>
            </div>
          </el-form-item> -->
        </el-form>
        <el-dialog
            title="选择采购人"
            :visible.sync="dialogShowpcom"
            width="50%">
            <div style="margin-bottom:20px;">
                <el-input style="width:80%;margin-right:20px;"
                  @change="searchCGR" @input="inputchange" v-model="comname" placeholder="请输入采购人名称" clearable/>
                <el-button  type="primary" @click="searchCGR">搜索</el-button>
            </div>
            <vggrid :list="pcomList" tableheight="600" flexname="" :cols="cols"
                    :showfooter="false" :showPage="true" :resizable="true"
                    :total="query.total" @pagechange="pagechange"
            >
            </vggrid>
          </el-dialog>
        <el-dialog
            title="选择委托协议"
            :visible.sync="dialogShowptc"
            width="80%">
            <div style="margin-bottom:20px;">
                <!-- <el-input 
                  style="width:80%;margin-right:20px;"
                  @change="searchCGR" 
                  @input="inputchange" 
                  v-model="comname" 
                  placeholder="请输入采购协议名称" 
                  clearable/>
                <el-button  type="primary" @click="searchCGR">搜索</el-button> -->
                <div class="search">
                  <div class="search_box">
                    <div class="searchItem">
                      <div class="label">协议编号</div>
                      <div class="field">
                        <el-input v-model.trim="ptcquery.ptccode" clearable ></el-input>
                      </div>
                    </div>
                    <div class="searchItem">
                      <div class="label">协议名称</div>
                      <div class="field">
                        <el-input v-model.trim="ptcquery.ptcname" clearable ></el-input>
                      </div>
                    </div>
                    <div class="searchItem">
                      <div class="label">采购人</div>
                      <div class="field">
                        <el-input v-model.trim="ptcquery.ptccomname" clearable ></el-input>
                      </div>
                    </div>
                    <div class="searchItem">
                      <div class="search_btn">
                        <el-button type='primary' @click="getptcPageList">查询</el-button>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <vggrid :list="ptcList" tableheight="600" flexname="" :cols="ptccols"
                    :showfooter="false" :showPage="true" :resizable="true" :defaultPage="10"
                    :total="ptcquery.total" @pagechange="ptcpagechange"
            >
            </vggrid>
          </el-dialog>
      </div>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadBtn from '../common/uploadBtn'
  import common from '@/mixin/common'
  import _ from 'lodash'
  import vggrid from '../common/vggrid'
  import amount from '../common/amount'

  const SUCCESS = 1
  export default {
    name: "projectAdd",
    mixins: [common],
    data () {
      return {
        project: {
          projectcode: '',
          projectauserid: '',
          projectacomid: '',
          projectatel: '',
          projectpuserid: '',
          projectpcomid: '',
          projectptel: '',
          pnid: '',
          pfsid: '',
          projectnoticeareacode:'',
          projectdoneflg: '1',
          projectperformancescore: '0.00'
          
        },
        ptcList:[],//采购协议
        dialogShowptc:false,//采购协议弹框
        areaList:[],//地区list
        cos: {},
        cols:[
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'comfullname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
          { title: '操作 ', showOverflow: true,width:100,
            slots: {
              default: ({row}) => {
                return [<vxe-button onClick={this.confirmCom.bind(this, row)}>确认</vxe-button>]
              }
            }
          }
        ],
        ptccols:[
          { field: 'ptccode', fieldtype: 'C', title: '协议编号',calculExpr:'',width:150,addNewRowFlg: false},
          { field: 'ptcname', fieldtype: 'C', title: '协议名称',calculExpr:'',addNewRowFlg: false},
          { field: 'ptcpcomname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
          { field: 'ptccreatename', fieldtype: 'C', title: '业务员',calculExpr:'',addNewRowFlg: false},
          { title: '操作 ', showOverflow: true,width:100,
            slots: {
              default: ({row}) => {
                return [<vxe-button type='primary' onClick={this.confirmPtc.bind(this, row)}>确认</vxe-button>]
              }
            }
          }
        ],
        comname:'',
        appendList: [],
        pmTreeList: [],
        pmList: [],
        puserList: [],
        auserList: [],
        projectprsflgList: [],
        projectdoneflgList: [],
        pojectpmflgList: [],
        projectpricecomputebasisList:[],
        quotationList:[],
        acomList: [],
        pcomList: [],
        pfsList: [],
        pnrecList: [],
        btnLoading: false,
        comsuserList: [],
        comList: {},
        // copy:[], // 评审方法复制对象
        // copy_val:[], // 评审方法复制对象二
        pmid: '',
        dialogShowpcom:false,
        query: {
          comneme: '',
          total: 0,
          limit: 20,
          offset: 0
        },
        ptcquery: {
          cosid: this.$store.getters.loginUser.cosid,
          ptcdptid:this.$store.getters.loginUser.userdptid,
          ptccreateuserid:this.$store.getters.loginUser.userid,
          ptcstatus:1,
          total: 0,
          limit: 10,
          offset: 0
        }
      }
    },
    created () {
      this.init()
    },
    filters:{
      qfwVal(value) {
        return utils.comdify(value)
      },
        toolongOmitted(val){
          if(val.length > 20){
            return val.substring(0,19) + '...' +val.substring(val.length - 4)
          }
          else{
            return val
          }
        }
    },
    mounted () {
    },
    async activated () {
      await this.init()
      await this.getPmList()
      this.getPrsflgList()
      this.getProjectdoneflgList()
      this.getPojectpmflgList()
      // this.getPcomList()
      this.getAcomList()
      this.getcomsuserList()
      this.getcomList()
      this.getareaList()
      await this.getPfsrecAndPnrecList()
      await this.getCos()
    },
    components: {uploadBtn,amount,vggrid},
    computed: {
      isScoreEdit () {
        if (+this.project.prsflg === 1 || +this.project.prsflg === 3 || +this.project.prsflg === 4 || +this.project.prsflg === 5) {
          if (+this.project.projectdoneflg === 4) { 
            return true
          }
        } else if(+this.project.prsflg === 2 || +this.project.prsflg === 6){ 
          if (+this.project.projectdoneflg === 5) { 
            return true
          }
        }  
        else {
          return false
        }
      },
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
      publicname () {
        if (this.project.prsflg == '4' || this.project.prsflg == '3') {
          return '底价公开'
        } else {
          return '预算公开'
        }
      },
      limitamtNmae(){
        if (this.project.prsflg == '3' || this.project.prsflg == '4') {
          return '项目底价'
        } else {
          return '项目预算'
        }  
      },
    },
    methods: {
      async getCos () {
        let data = await request({
          url: '/ywgl/cos/getCosbyid',
          method: "get",
          params: {cosid: this.$store.getters.loginUser.cosid}
        })
        this.cos = data[0]
      },
      async getPfsrecAndPnrecList () {
        this.pfsList = await request({
          url: '/xmgl/pfsrec/getPfsrecList',
          method: "get",
          params: {cosid: this.$store.getters.loginUser.cosid}
        })
        this.pnrecList = await request({
          url: '/xmgl/pnrec/getPnrecList',
          method: "get",
          params: {cosid: this.$store.getters.loginUser.cosid}
        })
      },
      prsflgChange (val) {
        this.$refs['ruleForm'].clearValidate()
        this.project.prsbjbegtime = ''
        this.project.prsbjendtime = ''
        this.project.projectlowamt = null
        // this.project.projectlimitamt = 0
        // this.$set(this.project,'projectlimitamt',null)
        // let model = ''
        // let basis = ''
        // if (val == '1') {
        //     model = this.projectdoneflgList.find(v => v.syscodeval == '1')
        //     this.projectpricecomputebasisList = this.copy_val
        //     this.projectpricecomputebasisList = this.projectpricecomputebasisList.filter(e=>{
        //       return e.syscodeval != 6 && e.syscodeval != 5
        //     })
        //     basis = this.projectpricecomputebasisList.find(v => v.syscodeval == '1')
        //     this.project.projectpricecomputebasisdesc = basis.syscodename
        //     this.$set(this.project,'projectpricecomputebasis',basis.syscodeval)
        //     // this.projectpricecomputebasisList = this.copy_val_o
        // } else if(val == '2') {
        //   model = this.projectdoneflgList.find(v => v.syscodeval == '3')
        //   this.projectpricecomputebasisList = this.copy
        // } else if(val == '4' || val == '3') {
        //     model = this.projectdoneflgList.find(v => v.syscodeval == '1')
        //     // this.projectpricecomputebasisList = this.copy_val_p
        //     this.projectpricecomputebasisList = this.copy_val
        //     this.projectpricecomputebasisList = this.projectpricecomputebasisList.filter(e=>{
        //       return e.syscodeval != 6 && e.syscodeval != 1
        //     })
        //     basis = this.projectpricecomputebasisList.find(v => v.syscodeval == '5')
        //     this.project.projectpricecomputebasisdesc = basis.syscodename
        //     this.$set(this.project,'projectpricecomputebasis',basis.syscodeval)
        // } else if(val == '5'){
        //     model = this.projectdoneflgList.find(v => v.syscodeval == '1')
        //     this.projectpricecomputebasisList = this.copy
        //     basis = this.projectpricecomputebasisList.find(v => v.syscodeval == '1')
        //     this.project.projectpricecomputebasisdesc = basis.syscodename
        //     this.$set(this.project,'projectpricecomputebasis',basis.syscodeval)
        // } else if(val == '6'){
        //     this.getpricecomputebasisList()
        // }
        this.getProjectdoneflgList()
        this.getpricecomputebasisList()
        if(val == '4' || val == '5'){
          this.$set(this.project,'projectysflg',true)
          this.$set(this.project,'projecthsflg',true)
        }
        // if (model) {
        //   this.project.projectdoneflgdesc = model.syscodename
        //   this.project.projectdoneflg = model.syscodeval
        // }
        this.$set(this.project,'projectquotationmode','1')
        this.getQuotation()
      },
      validateProjectcode (rul, val, callback) {
        this.project.projectcode = _.trim(val)
        this.validateData('项目编号不能重复', 'projectrec', 'projectid', 'projectcode', val, callback)
      },
      validateData (msg, tablename, fieldid, checkfield, checkval, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename, fieldid, checkfield, checkval: this.project[checkfield], id: this.project.projectid}
        }).then(res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
      async showPcom(){
        this.dialogShowpcom = true
        this.getSearchPcomList()
      },
      async getSearchPcomList(){
          this.query.cosid = this.$store.getters.loginUser.cosid
          this.query.comtype = '2'
          //代理单位
          if (this.$store.getters.loginUser.comtype === '1') {
            this.query.comid = null
          }
          //采购人
          if (this.$store.getters.loginUser.comtype === '2') {
            this.query.comid = this.$store.getters.loginUser.usercomid
          }
          this.query.comcodename = this.comname

          let res = await request({
            method: 'get',
            url: '/ywgl/com/getPageList',
            params: this.query
          })
          this.pcomList = res.list
          this.query.total = res.count[0].count
      },
      async confirmCom(row){
          this.project.pcomfullname = row.comfullname
          this.project.projectpcomid = row.comid
          await this.getpUserList (row.comid)
          this.dialogShowpcom = false
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getSearchPcomList()
      },
      async ptcpagechange (page){
        this.ptcquery.offset = page.pageSize * (page.currentPage - 1)
        this.ptcquery.limit = page.pageSize
        this.getptcPageList()

      },
      async searchCGR(){
          this.getSearchPcomList()
      },
      scoreFixed (el, name) {
        let inputVal = el.target.value || ''
        this.project[name] = Number(inputVal).toFixed(2)
      },
      inputMoney (el, name) {
        let val = utils.delcommafy(el.target.value)
        var reg = /^[0-9]+.?[0-9]*$/
        if ((reg.test(val))) {
          this.project[name] = utils.getInputValue(el)
        }
      },
      async init () {
        this.btnLoading = false
        this.project = {
          projectcode: '',
          projectauserid: '',
          projectacomid: '',
          projectatel: '',
          projectpuserid: '',
          projectpcomid: '',
          projectptel: '',
          pnid: '',
          pfsid: '',
          projectnoticeareacode:'',
          projectdoneflg: '1',
          projectperformancescore: '0.00'
          
        }
        // this.project.projectno = await request({
        //   url: '/xmgl/project/genProjectNo',
        //   method: "post",
        //   data: {cosid: this.$store.getters.loginUser.cosid, genflg: 0}
        // })
        // this.project.projectcode = this.project.projectno
        if (this.$store.getters.loginUser.comtype == '2') {
          // // 自采默认采购人和人
          this.project.projectpcomid = this.$store.getters.loginUser.comid
          this.project.projectpcomname = this.$store.getters.loginUser.comfullname
          await this.getpUserList(this.project.projectpcomid)
          this.project.projectpuserid = this.$store.getters.loginUser.userid
          this.project.projectpusername = this.$store.getters.loginUser.username
          this.project.projectptel =this.project.projectpusername + " " + this.$store.getters.loginUser.usertel
        }
        if (this.$store.getters.loginUser.comtype == '1') {
          this.project.projectacomid = this.$store.getters.loginUser.comid
          this.project.acomfullname = this.$store.getters.loginUser.comfullname
          await this.getaUserList(this.project.projectacomid)
          // this.project.projectauserid = this.$store.getters.loginUser.userid
          this.$set(this.project,'projectauserid',this.$store.getters.loginUser.userid)
          this.project.ausername = this.$store.getters.loginUser.username
          this.project.projectatel = this.project.ausername + " " + this.$store.getters.loginUser.usertel
          this.$set(this.project,'projectpricecomputebasis',null)
        }
        this.$set(this.project,'projectysflg',true)
        this.$set(this.project,'projecthsflg',true)
        this.$set(this.project,'projectisqcheck','')
        this.project.projectnoticeareacode = ''
        this.project.pcomfullname = ''
        this.project.pfsid = ''
        this.project.pnid = ''
        this.appendList = []
        await this.getpricecomputebasisList()
      },
      async getPrsflgList () {
        this.projectprsflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'prsflg'}
        })
      },
      //报价方式更改
      async quotationmodeChange(value){
        this.$set(this.project,'projectquotationmode',value)
        this.$forceUpdate();
      },
      //报价方式
      async getQuotation () {
        let res = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'quotationmode'}
        })
        if(+this.project.prsflg === 1 || +this.project.prsflg === 6){
          res = res.filter(e=>e.syscodeseq !== 2)
        } else if(+this.project.prsflg === 3){
          res = res.filter(e=>e.syscodeseq !== 3 && e.syscodeseq !== 4)
        }
        this.quotationList = res
      },
      async getPojectpmflgList () {
        this.pojectpmflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'chargefeetype'}
        })
      },
      async getPmList () {
        let data = await request({
          method: 'get',
          url: '/basic/pm/getPmTree',
          params: {cosid: this.$store.getters.loginUser.cosid}
        })
        this.pmTreeList = data.list
        this.pmList = data.data
      },
      async getpUserList (comid) {
        this.puserList = await request({
          method: 'get',
          url: '/xtgl/user/getUserList',
          params: {comid: comid}
        })
        if(this.puserList.length > 0){
          this.project.projectpuserid = this.puserList[0].userid
          await this.getpUserTel(this.project.projectpuserid)
        }
        // this.project.projectptel = ''
      },
      async getaUserList (comid) {
        this.auserList = await request({
          method: 'get',
          url: '/xtgl/user/getUserList',
          params: {comid: comid}
        })
      },
      async getaUserTel (userid) {
        let user = this.auserList.find(item => (item.userid === userid))
        console.log('-------user---------',user);
        // this.project.projectatel = user.username + " " +user.usertel
        this.$set(this.project,'projectatel',user.username + " " + user.usertel)
      },
      async getpUserTel (userid) {
        let user = this.puserList.find(item => (item.userid === userid))
        // this.project.projectptel = user.username + " " +user.usertel
        this.$set(this.project,'projectptel',user.username + " " +user.usertel)
      },
      async getPcomList () {
        let model = {cosid: this.$store.getters.loginUser.cosid, comtype: '2'}
        //代理单位
        if (this.$store.getters.loginUser.comtype === '1') {
          model.comid = null
        }
        //采购人
        if (this.$store.getters.loginUser.comtype === '2') {
          model.comid = this.$store.getters.loginUser.usercomid
        }
        this.pcomList = await request({
          method: 'get',
          url: '/ywgl/com/getComList',
          params: model
        })
        //业务员
        // if (!this.project.projectsuserid) {
        //   this.$set(this.project, 'projectsuserid', this.pcomList[0].comsuserid)
        // }
      },
      async getAcomList () {
        let model = {cosid: this.$store.getters.loginUser.cosid, comtype: '1'}
        //代理单位
        if (this.$store.getters.loginUser.comtype === '1') {
          model.comid = this.$store.getters.loginUser.usercomid
        }
        //采购人
        if (this.$store.getters.loginUser.comtype === '2') {
          model.comid = this.$store.getters.loginUser.usercomid
        }
        this.acomList = await request({
          method: 'get',
          url: '/ywgl/com/getComList',
          params: model
        })
        // console.log('this.acomList[0]',this.acomList[0]);
        //业务员
        // if (!this.project.projectsuserid) {
        //   this.$set(this.project, 'projectsuserid', this.acomList[0].comsuserid)
        // }
      },
      delappend (file) {
        this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(() => {
          let index = this.appendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.appendList.splice(index, 1)
        }).catch(() => {
        })
      },
      async setfile (path, filename) {
        let append = {
          appendid: 0,
          appendfromid: 0,
          appendfromtype: '7',
          appendtype: '100',
          appendseq: this.appendList.length + 1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr, '')
        }
        this.appendList.push(append)
      },
      async addOrEdit () {
        this.btnLoading = true
        this.submitForm('ruleForm').then(async() => {
          this.project.prsbmneedconfirm = 1 // 报名方式
          this.project.prschangeflg = 1  // 服务费默认方式
          this.project.prsisopen = 2  //轮次底价
          this.project.prsnmin = 3 //竞拍默认时间
          this.project.cosid = this.$store.getters.loginUser.cosid
          this.project.userid = this.$store.getters.loginUser.userid
          this.project.projectcuserid = this.$store.getters.loginUser.userid
          this.project.projectmuserid = this.$store.getters.loginUser.userid
          this.project.projectysflg = this.project.projectysflg === true ? '1' : '0'
          this.project.projecthsflg = this.project.projecthsflg === true ? '1' : '0'
          this.project.prsbjtimes= 1
          if (+this.project.prsflg === 1 || +this.project.prsflg === 3) {
            this.project.projectjjfile = 1
          }else {
            this.project.projectjjfile = 0
          }
          if (this.$store.getters.loginUser.comtype == '2') {
            this.project.projecttype = 2
            this.project.projectacomid = null
            this.project.projectauserid = null
            this.project.projectatel = null
          }
          if (this.$store.getters.loginUser.comtype == '1') {
            this.project.projecttype = 1
          }

          if (this.project.projectpmid.length > 1) {
            this.project.projectpmid = this.project.projectpmid[this.project.projectpmid.length-1]
          }
          // let pmModel = this.pmList.find(v => +v.pmid == +this.project.projectpmid)
          // if(pmModel) {
          //   this.project.projectchargefeetype = pmModel.pmchargefeetype
          // }
          this.project.projectlimitamt = utils.delcommafy(this.project.projectlimitamt)
          this.project.appends = this.appendList
          if (this.appendList.length) {
            this.project.appendfromtype = this.appendList[0].appendfromtype
          }
          if (+this.cos.cosprojectcodeflag === 1) {
           let data = await request({
              url: '/xmgl/project/isProjectCodeFlag',
              method: "get",
              params: {userid: this.$store.getters.loginUser.userid}
           })
           if (!data.usernumber) {
             this.$message.error('项目员编号不能为空,请联系管理员!') 
             return
            }
          if (!data.comnumber) {
            this.$message.error('代理编号不能为空,请联系管理员!') 
            return
          }
          if (!data.dptcode) {
            this.$message.error('部门编号不能为空,请联系管理员!') 
            return
          }
          }
          let data = await request({
            url: '/xmgl/project/addOrEdit',
            method: "post",
            data: this.project
          })
          if (data.issuccess === 1) {
            this.close()
            this.$refs['ruleForm'].resetFields()
            this.$message.success('保存成功')
            this.$router.push({name: 'projectEdit', params: {projectid: data.data.projectid}})
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
        this.btnLoading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'projectIndex'})
      },
      async getcomsuserList () {
        let query = {
          comid: this.$store.getters.loginUser.usercomid
        }
        let res = await request({
          method: 'get',
          url: '/xtgl/user/getPageList',
          params: query
        })
        this.comsuserList = res.list
      },
      async getcomList () {
        //获取公司信息
        let data = await request({
          method: 'get',
          url: '/xtgl/user/getUser',
          params: {userid: this.$store.getters.loginUser.userid}
        }) 
        this.comList = data[0]
        this.project.projectbidaddr = this.comList.comaddr
        this.project.projectnoticeareacode = this.comList.dptareacode
      },
      //获取地区list
      async getareaList(){
        let res = await request({
          method: 'get',
          url: '/xtgl/dpt/getDptareaList',
          params: {cosid:this.$store.getters.loginUser.cosid}
        })
        this.areaList = res
      },
      changeArea(value){
        this.project.projectnoticeareacode = value
        this.$forceUpdate();
      },
      inputchange(e){
        this.comname = e.replace(/[, ]/g,'')
      },
      projectdoneflgChange(val){
          this.$set(this.project,'projectdoneflg',val)
          if (+val === 3) {
            this.project.projectisqcheck = 1
            this.$refs['ruleForm'].clearValidate()
            // this.projectpricecomputebasisList = this.copy
          }
          if(+val === 1){
            this.project.projectisqcheck = ""
            // this.projectpricecomputebasisList = this.copy_val
          }
      },
      pricecomputebasisChange(val){
        this.$set(this.project,'projectpricecomputebasis',val)
      },
      async getProjectdoneflgList () {
        // this.projectdoneflgList
        let res = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectdoneflg'}
        })
        this.projectdoneflgList = res
        if(+this.project.prsflg === 1 || +this.project.prsflg === 3 || +this.project.prsflg === 4 || +this.project.prsflg === 5){
            let desc = res.filter(e => {
              return +e.value === 1
            })
            this.projectdoneflgList = res.filter(item => ['1', '4'].includes(item.value)).sort((a, b) => +a.syscodeseq - +b.syscodeseq)
            this.project.projectdoneflg = '1'
            // this.$set(this.project,'projectdoneflg',desc[0].syscodeval)
            // this.$set(this.project,'projectdoneflgdesc',desc[0].syscodename)
        } else if(+this.project.prsflg === 2 || +this.project.prsflg === 6){
            let desc = res.filter(e => {
              return +e.value === 3
            })
            this.projectdoneflgList = res.filter(item => ['3', '5'].includes(item.value)).sort((a, b) => +a.syscodeseq - +b.syscodeseq)
            this.project.projectdoneflg = '3'
            // this.$set(this.project,'projectdoneflg',desc[0].syscodeval)
            // this.$set(this.project,'projectdoneflgdesc',desc[0].syscodename)
        }
      },
      async getpricecomputebasisList () {
        let res = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectpricecomputebasis'}
        })
        this.projectpricecomputebasisList = res
        if(+this.project.prsflg === 1){//综合必选
            this.projectpricecomputebasisList = res.filter(e => {
                return +e.value !== 6 && +e.value !== 5
            })
            this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
        }
        else if (+this.project.prsflg === 3){
            this.projectpricecomputebasisList = res.filter(e => {
                return +e.value !== 6 && +e.value !== 1
            })
            this.project.projectpricecomputebasis = this.projectpricecomputebasisList[1].value
        }
        else if(+this.project.prsflg === 6){//综合必选
            this.projectpricecomputebasisList = res.filter(e => {
                return +e.value !== 6
            })
            this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
        }
        else if(+this.project.prsflg === 4 ||+this.project.prsflg === 5){
            this.projectpricecomputebasisList = res.filter(e => {
                return +e.value !== 6 && +e.value !== 2
            })
            if(+this.project.prsflg === 4){
              this.project.projectpricecomputebasis = this.projectpricecomputebasisList[1].value
              this.$set(this.project,'projectpricecomputebasisdesc',this.projectpricecomputebasisList[1].label)
            }else{
              this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
              this.$set(this.project,'projectpricecomputebasisdesc',this.projectpricecomputebasisList[0].label)
            }
        }
      },
      async getptcPageList(){
          this.loading = true
          let res = await request({
            url: '/xmgl/ptc/getptcAddList',
            method: "get",
            params: this.ptcquery
          })
          this.ptcList = res.list
          this.ptcquery.total = res.count[0].count
          this.loading = false
      },
      async showptcBox() {
          this.dialogShowptc = true
          await this.getptcPageList()
      },
      async confirmPtc(row){
        //确认协议
        this.project.dptid = row.ptcdptid
        this.project.ptcinfo = '('+row.ptccode+')' + row.ptcname
        this.project.projectptccode = row.ptccode //协议编号
        this.project.projectptcid = row.ptcid//协议id
        this.project.projectsuserid = row.ptccreateuserid //业务员id——协议的创建人
        this.project.pcomfullname = row.comfullname  //采购人名称
        this.project.projectpcomid = row.comid   //采购人id
        this.project.cdptname = row.cdptname
        this.project.dptusername = row.username
        // this.project.projectname = row.ptcname
        this.$set(this.project,'prsflg',row.ptctrademode)//交易方式
        this.$set(this.project,'projectname',row.ptcname)//项目名称——>采用默认协议名称
        await this.getpUserList (row.comid)
        await this.getpUserTel (row.ptctpuserid)  //采购联系人id
        this.$set(this.project,'projectpuserid',row.ptctpuserid)
        await this.prsflgChange(row.ptctrademode)//会把项目预算置为空，所以要放在预算前面执行
        this.$set(this.project,'projectlimitamt',row.ptcbudgetamt?utils.comdify(utils.delcommafy(row.ptcbudgetamt)):null)//项目预算
        this.dialogShowptc = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";
  .filelist{
    width: 100%;
  }
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content-title{
      display: flex;
      .el-input{
        width: 514px;
      }
      .el-cascader{
        width: 200px;
      }
    }
    .content .el-textarea__inner, .el-textarea {
      width: 840px;
    }
    .file {
      display: flex;
      flex-direction: column;
      // width: 50%;
      .uploadbtn {
        display: flex;
        span {
          padding-left: 10px;
          color: red;
        }
      }
    }
    .checkbox_w {
      width: 45px;
    }
  }
 .mainfrom .el-input{
   line-height: 0;
 }
</style>
